module.exports = __webpack_public_path__ + "img/Convertible_Back.604dfa3d.svg";